import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import AdapterJalali from "@date-io/date-fns-jalali";
import DivisionComponent from "../../components/cards/DevisionComponent";
import DivisionCmp from "../../components/cards/DivisionCmp";
import AlertCmp from "../../components/alert/AlertCmp";
import ModalVerify from "../../components/modals/ModalVerify";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Formik } from "formik";
import {
  CustomerInfo,
  RegisterLoanBySupplierRequest,
  RegisterLoanBySupplierResponse,
} from "../../models/loan.model";
import { registerLoanBySupplier } from "../../services/loan.service";
import { useMutation, useQuery, useQueryClient } from "react-query";
import Button from "@mui/material/Button";
import ModalCmp from "../../components/modals/ModalCmp";
import { REFERENCE_KEY, SUPPLIER_CREDIT } from "../../config/cacheKey";
import { GetSupplierCredit as getSupplierCredit } from "../../services/supplier.service";
import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { getTokenClaims } from "../../services/auth.service";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { convertToLocalDateTime } from "../../utility/dateUtility";
import DropdownCmp from "../../components/dropdown/DropdownCmp";
import InputIcon from "react-multi-date-picker/components/input_icon";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import PriceFeildComponent from "../../components/priceFeild/priceFeildComponent";
import StepperCMP from "../../components/stepperCMP/StepperCMP";
import ModalCancelLoan from "../../components/modals/ModalCancelLoan";

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});


function RegisterNewRequest_({ handelDisplayFacility }: any) {
  const queryClient = useQueryClient();
  const [openValidationModel, setOpenValidationModel] = React.useState(false);
  const [validationMessages, setValidationMessages] = React.useState<string[]>(
    []
  );
  const [openVerifyModal, setOpenVerifyModal] = React.useState(false);
  const [customerInfo, setCustomerInfo] = React.useState<CustomerInfo>(
    (): CustomerInfo => {
      let customerInfo = new CustomerInfo();
      return customerInfo;
    }
  );
  const [birthDate, setBirthDate] = React.useState<number | undefined>();
  // const { data: supplierCredit } = useQuery<number>(
  //   SUPPLIER_CREDIT,
  //   (): Promise<number> => {
  //     return getSupplierCredit({ loanTemplateId: 6 });
  //   }
  // );
  const registerLoanBySupplierMutation = useMutation(registerLoanBySupplier, {
    onSuccess: (data: RegisterLoanBySupplierResponse) => {
      setOpenValidationModel(false);
      setOpenVerifyModal(false);
      if (data) {
        if (!data.isValid) {
          setOpenValidationModel(true);
          setValidationMessages(data.validationIssues);
        }
        if (data.isValid) {
          setOpenVerifyModal(true);
          setCustomerInfo(data.customerInfo);
          queryClient.setQueryData(REFERENCE_KEY, data.referenceKey);
        }
      }
    },
  });

  return (
    <Box sx={{ flexGrow: 1}}>
      <StepperCMP />
    </Box>
  );
}
export default function RegisterNewRequest({ handelDisplayFacility }: any) {
  const parentChild = (
    <div style={{height:'8px'}}></div>
  );
  const child = (
    <RegisterNewRequest_ handelDisplayFacility={handelDisplayFacility} />
  );
  return (
    
    <div>
      <DivisionCmp child={child} />
    </div>

  );
}

const onKeyDown = (e: any) => {
  e.preventDefault();
};
const options = [
  { id: 12, text: "12" },
  { id: 24, text: "24", selected: true },
];
